// Tiny classnames helper (joins truthy parts).
export type CxArg = string | false | null | undefined | 0;
export const cx = (...a: CxArg[]): string => a.filter(Boolean).join(" ");
